import { Box } from "styles/globalComponents";
import { MonthsOptions } from "Components/MonthsOptions";
import { Loader } from "Components/Loader";
import { DateTime } from "Components/Cards/DateTime";
import { ReactNode } from "react";
import { useSelectAppointment } from "Hooks/useSelectAppointment";
import { SelectScheduleContainer } from "./styles";

interface SelectAppointmentProps {
  clientId: number;
  preOrderId: number;
  zipcode: string;
  onSelectAppointment: (schedule: string) => void;
  children?: ReactNode;
}

export const SelectAppointment = ({
  clientId,
  preOrderId,
  zipcode,
  onSelectAppointment,
  children,
}: SelectAppointmentProps) => {
  const {
    availableDates,
    dateRequest,
    setDateRequest,
    capitilizedMonth,
    appointment,
    availableHours,
    handleSelectDate,
    handleSelectHour,
    setDefaultAppointment,
    appointmentTypeID,
    setAppointmentTypeID,
  } = useSelectAppointment({
    clientId,
    preOrderId,
    zipcode,
  });

  const handleSelectAppointment = (schedule: { option: string }) => {
    handleSelectHour(schedule);
    onSelectAppointment(schedule.option);
  };

  const onSelectAppointmentType = (id: number) => {
    setAppointmentTypeID(id);
  };
  return (
    <SelectScheduleContainer>
      <div>
        <div className="available-months">
          <p className="text-center text-purple schedule-searching text-md">
            Próximos meses
          </p>
          <MonthsOptions
            selectedMonth={dateRequest}
            setRequestMonth={setDateRequest}
            blockedClick={!availableDates.isSuccess}
            setAppointmentInfo={setDefaultAppointment}
          />
        </div>

        {availableDates?.data?.length === 0 && (
          <div className="available-months">
            <p className="text-center text-purple schedule-searching text-md">
              Ainda não há data disponível para o mês selecionado
            </p>
          </div>
        )}

        {availableDates.isError && (
          <p className="text-center text-centered text-purple schedule-searching text-md error">
            {" "}
            {availableDates.error as string}
          </p>
        )}

        {availableDates.isLoading ? (
          <Box display="flex" justify="center" mt="40">
            <Loader />
          </Box>
        ) : null}

        {availableDates?.data?.length >= 1 && (
          <div className="datetime-result-list">
            <p className="text-center text-purple schedule-searching text-md">
              Datas disponíveis em {capitilizedMonth}
            </p>

            <div className="container-dates-options">
              <div className="dates-list">
                {availableDates?.data?.map((date: any) => (
                  <DateTime
                    dateTimeInfo={date}
                    key={date.date}
                    onSelectDate={handleSelectDate}
                    selectedDateTime={appointment.query_date}
                  />
                ))}
              </div>
            </div>

            {availableHours.isLoading ? (
              <Box display="flex" justify="center" mt="40">
                <Loader />
              </Box>
            ) : null}

            {availableHours?.data && availableHours?.data?.length > 1 && (
              <div className="container-times-options">
                <p className="text-center text-purple schedule-searching text-md">
                  Horários disponíveis
                </p>
                <div className="dates-list">
                  {availableHours?.data?.map((time: any) => (
                    <DateTime
                      dateTimeInfo={time}
                      key={time.time}
                      onSelectDate={handleSelectAppointment}
                      selectedDateTime={appointment.query_hour}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {children}
      </div>
    </SelectScheduleContainer>
  );
};
